import { render } from "./FooterBar.vue?vue&type=template&id=14873fe1&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=14873fe1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14873fe1"]])

export default __exports__